export default __webpack_public_path__ + "static/media/2175.56bea3c2.png";